import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { CheckCircleIcon, XCircleIcon, ArrowRightIcon, LinkIcon, FileTextIcon, ReceiptIcon } from 'lucide-react';
const Integrations = () => {
  // In a real app, this would come from an API or context
  const [connectedSoftware, setConnectedSoftware] = useState<string | null>('Xero');
  const accountingSoftware = [{
    id: 'xero',
    name: 'Xero',
    description: 'Connect your Xero account to automatically sync invoices and bills.',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/5c/Xero_logo.svg/1200px-Xero_logo.svg.png',
    isConnected: connectedSoftware === 'Xero'
  }, {
    id: 'myob',
    name: 'MYOB',
    description: 'Connect your MYOB account to automatically sync invoices and bills.',
    logo: 'https://upload.wikimedia.org/wikipedia/en/thumb/8/86/MYOB_logo.svg/1200px-MYOB_logo.svg.png',
    isConnected: connectedSoftware === 'MYOB'
  }, {
    id: 'quickbooks',
    name: 'QuickBooks',
    description: 'Connect your QuickBooks account to automatically sync invoices and bills.',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/e/e5/Quickbooks_new_logo.png',
    isConnected: connectedSoftware === 'QuickBooks'
  }];
  const handleConnect = (softwareName: string) => {
    // In a real app, this would initiate an OAuth flow
    setConnectedSoftware(softwareName);
  };
  const handleDisconnect = () => {
    // In a real app, this would revoke access tokens
    setConnectedSoftware(null);
  };
  return <div className="space-y-6" data-id="element-602">
      <div data-id="element-603">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-604">Integrations</h1>
        <p className="mt-1 text-sm text-gray-500" data-id="element-605">
          Connect your accounting software to automatically sync invoices and
          bills
        </p>
      </div>
      {connectedSoftware && <div className="bg-blue-50 border border-blue-200 rounded-lg p-4" data-id="element-606">
          <div className="flex items-start" data-id="element-607">
            <div className="flex-shrink-0" data-id="element-608">
              <LinkIcon className="h-5 w-5 text-blue-600" data-id="element-609" />
            </div>
            <div className="ml-3" data-id="element-610">
              <h3 className="text-sm font-medium text-blue-800" data-id="element-611">
                Connected to {connectedSoftware}
              </h3>
              <div className="mt-2 text-sm text-blue-700" data-id="element-612">
                <p data-id="element-613">
                  Your {connectedSoftware} account is connected. Your invoices
                  and bills are being synced automatically.
                </p>
              </div>
              <div className="mt-4 flex space-x-4" data-id="element-614">
                <Link to="/invoices" className="inline-flex items-center text-sm font-medium text-blue-600 hover:text-blue-500" data-id="element-615">
                  <FileTextIcon className="h-4 w-4 mr-1" data-id="element-616" />
                  View Invoices
                </Link>
                <Link to="/bills" className="inline-flex items-center text-sm font-medium text-blue-600 hover:text-blue-500" data-id="element-617">
                  <ReceiptIcon className="h-4 w-4 mr-1" data-id="element-618" />
                  View Bills
                </Link>
              </div>
            </div>
          </div>
        </div>}
      <div className="bg-white shadow overflow-hidden sm:rounded-lg" data-id="element-619">
        <div className="px-4 py-5 sm:px-6" data-id="element-620">
          <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-621">
            Accounting Software
          </h3>
          <p className="mt-1 max-w-2xl text-sm text-gray-500" data-id="element-622">
            Connect your accounting software to LucaGet
          </p>
        </div>
        <div className="border-t border-gray-200" data-id="element-623">
          <ul className="divide-y divide-gray-200" data-id="element-624">
            {accountingSoftware.map(software => <li key={software.id} className="px-4 py-4 sm:px-6" data-id="element-625">
                <div className="flex items-center justify-between" data-id="element-626">
                  <div className="flex items-center" data-id="element-627">
                    <div className="flex-shrink-0 h-12 w-12 bg-white rounded-md overflow-hidden" data-id="element-628">
                      <img src={software.logo} alt={software.name} className="h-12 w-12 object-contain" data-id="element-629" />
                    </div>
                    <div className="ml-4" data-id="element-630">
                      <h4 className="text-lg font-medium text-gray-900" data-id="element-631">
                        {software.name}
                        {software.isConnected && <span className="ml-2 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-632">
                            Connected
                          </span>}
                      </h4>
                      <p className="mt-1 text-sm text-gray-500" data-id="element-633">
                        {software.description}
                      </p>
                    </div>
                  </div>
                  <div data-id="element-634">
                    {software.isConnected ? <button onClick={() => handleDisconnect()} className="inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-635">
                        <XCircleIcon className="h-4 w-4 mr-1.5 text-red-500" data-id="element-636" />
                        Disconnect
                      </button> : <button onClick={() => handleConnect(software.name)} className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-637">
                        <LinkIcon className="h-4 w-4 mr-1.5" data-id="element-638" />
                        Connect
                      </button>}
                  </div>
                </div>
              </li>)}
          </ul>
        </div>
      </div>
      <div className="bg-white shadow sm:rounded-lg" data-id="element-639">
        <div className="px-4 py-5 sm:p-6" data-id="element-640">
          <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-641">
            Benefits of Connecting Your Accounting Software
          </h3>
          <div className="mt-2 max-w-xl text-sm text-gray-500" data-id="element-642">
            <p data-id="element-643">
              Connecting your accounting software to LucaGet provides several
              advantages:
            </p>
          </div>
          <div className="mt-5" data-id="element-644">
            <ul className="space-y-4" data-id="element-645">
              <li className="flex items-start" data-id="element-646">
                <div className="flex-shrink-0" data-id="element-647">
                  <CheckCircleIcon className="h-5 w-5 text-green-500" data-id="element-648" />
                </div>
                <div className="ml-3 text-sm text-gray-700" data-id="element-649">
                  <span className="font-medium" data-id="element-650">Automatic Invoice Syncing</span>
                  <p className="mt-1" data-id="element-651">
                    Your invoices will automatically appear in LucaGet, so you
                    can track payments without manual entry.
                  </p>
                </div>
              </li>
              <li className="flex items-start" data-id="element-652">
                <div className="flex-shrink-0" data-id="element-653">
                  <CheckCircleIcon className="h-5 w-5 text-green-500" data-id="element-654" />
                </div>
                <div className="ml-3 text-sm text-gray-700" data-id="element-655">
                  <span className="font-medium" data-id="element-656">Bill Management</span>
                  <p className="mt-1" data-id="element-657">
                    Keep track of bills you need to pay, with automatic syncing
                    from your accounting software.
                  </p>
                </div>
              </li>
              <li className="flex items-start" data-id="element-658">
                <div className="flex-shrink-0" data-id="element-659">
                  <CheckCircleIcon className="h-5 w-5 text-green-500" data-id="element-660" />
                </div>
                <div className="ml-3 text-sm text-gray-700" data-id="element-661">
                  <span className="font-medium" data-id="element-662">Reconciliation</span>
                  <p className="mt-1" data-id="element-663">
                    Payments received through LucaGet will be automatically
                    reconciled in your accounting system.
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>;
};
export default Integrations;